import { combineReducers } from "redux";

import { IStoreState } from "./initialStoreState";
import { messageReducer } from "./messages/messagesReducer";

import { commonReducer } from "./common/commonReducer";

import { UserProfileReducer } from "./UserProfileList/userProfileReducer";

import { activityReducer } from "./activity/activityReducer";
import { customizerReducer } from "./customizer/customizerReducer";
import { leadsReducer } from "./leads/leadsReducer";
import { opportunitesReducer } from "./opportunites/opportunitesReducer";
import { studentReducer } from "./student/studentReducer";
import { templateReducer } from "./templates/templateReducer";

import { securityReducer } from "./security/securityReducer";
import { userDocumentReducer } from "./userDocument/userDocumentReducer";
import { userBranchReducer } from "./userBranch/userBranchReducer";
import { envConfigReducer } from "./envConfig/envConfigReducer";
import { companyInformationReducer } from "./CompanyInformation/companyInformationReducer";
import { bookingReducer } from "./booking/bookingReducer";
import { categoryReducer } from "./category/categoryReducer";
import { categoryTypeReducer } from "./categoryType/categoryTypeReducer";

import { marketCampaignReducer } from "./marketCampaign/marketCampaignReducer";
import { googleReviewReducer } from "./Review/reviewReducer";
import { companyOutletReducer } from "./companyOutlet/companyOutletReducer";
import { paymentDetailsReducer } from "./paymentDetails/paymentDetailsReducer";
import { metaDataReducer } from "./metaData/metaDataReducer";
import { contactsReducer } from "./contacts/contactsReducer";
import { bankDetailsReducer } from "./bankDetails/bankDetailsReducer";

import { companyOutletAddressReducer } from "./customerDeliveryAddress/companyOutletAddressReducer";
import { companyOutletAttachmentReducer } from "./customerVendorAttachment/companyOutletAttachmentReducer";
import { subscriptionPlanReducer } from "./subscription/subscriptionReducer";

import { orgEnvConfigReducer } from "./orgEnvConfig/orgEnvConfigReducer";
import { automationReducer } from "./automation/automationReducer";
import { statusReducer } from "./status/statusReducer";
// import { metaTemplateReducer } from "./metaTemplate/metaTemplateReducer";
import { foodReducer } from "./food/foodReducer";
import chatbotReducer from "./chatbot/chatbotReducer";
import { supportReducer } from "./support/supportReducer";
import { masterFormsReducer } from "./masterForm/masterFormsReducer";
import { serviceReducer } from "./service/serviceReducer";
import { eventReducer } from "./event/eventReducer";
import { formsReducer } from "./dynamicFormsV2/formsReducer";
import { genAiReducer } from "./genAi/genAiReducer";
import { reviewQuestionnaireReducer } from "./ReviewQuestionnaire/ReviewQuestionnaireReducer";
import { whatsappTemplateReducer } from "./whatsappTemplate/whatsappTemplateReducer";
import { actionItemReducer } from "./actionItems";
import { quickReplyTemplateReducer } from "./quickReplyTemplates/quickReplyTemplateReducer";
import { masterQuickReplyTemplateReducer } from "./masterQuickReplyTemplates/masterQuickReplyTemplateReducer";
import { intentsReducer } from "./Intents/IntentsReducer";
import { catalogsReducer } from "./Catalogs/CatalogsReducer";
import { variantsReducer } from "./variants/variantsReducer";
import { upsellLeadsReducer } from "./upsellLead/upsellLeadsReducer";
import { actionItemCategoriesReducer } from "./ActionItemCategory/ActionItemCategoryReducer";
import { actionItemDynamicFormReducer } from "./actionItemDynamicForm/actionItemDynamicFormReducer";
import { restrictedWordsReducer } from "./restrictedWords/restrictedWordsReducer";
import { reportRevenueReducer } from "./Report/ReportReducer";
import { messageSequenceReducer } from "./MessageSequence/MessageSequenceReducer";
import { sequenceDebugReducer } from "./SequenceDebug/SequenceDebugReducer";
import { moduleSettingReducer } from "./moduleSetting";
import { roomReducer } from "./room/roomReducer";
import { agentToolsReducer } from "./AgentTools/AgentToolsReducer";
import { catalogProductsReducer } from "./CatalogProducts/CatalogProductsReducer";


import { externalLeadsLifeCycleReducer } from "./external-leads/external-leads-life-cycle";
import { onboardingChecklistReducer } from "./onboardingChecklist/onboardingChecklistReducer";

const appReducer = combineReducers({  customizerReducer: customizerReducer,
  student: studentReducer,
  message: messageReducer,
  acitivty: activityReducer,
  security: securityReducer,

  templates: templateReducer,

  userprofile: UserProfileReducer,
  common: commonReducer,
  companyInformation: companyInformationReducer,

  opportunites: opportunitesReducer,
  leads: leadsReducer,

  userDocument: userDocumentReducer,
  userBranch: userBranchReducer,
  envConfig: envConfigReducer,
  booking: bookingReducer,
  category: categoryReducer,
  categoryType: categoryTypeReducer,
  food: foodReducer,
  marketCampaign: marketCampaignReducer,
  review: googleReviewReducer,
  companyOutlet: companyOutletReducer,
  bankDetails: bankDetailsReducer,
  contacts: contactsReducer,
  companyOutletAddress: companyOutletAddressReducer,
  companyOutletAttachment: companyOutletAttachmentReducer,

  payment_details: paymentDetailsReducer,
  metaData: metaDataReducer,
  subscriptionPlan: subscriptionPlanReducer,
  orgEnvConfig: orgEnvConfigReducer,
  automation: automationReducer,
  status: statusReducer,
  // metaTemplate: metaTemplateReducer,
  whatsappTemplate: whatsappTemplateReducer,
  quickReplyTemplate: quickReplyTemplateReducer,
  masterQuickReplyTemplate: masterQuickReplyTemplateReducer,
  chatbot: chatbotReducer,
  support: supportReducer,
  forms: formsReducer,
  masterForms: masterFormsReducer,
  service: serviceReducer,
  event: eventReducer,
  genAi: genAiReducer,
  reviewQuestionnaire: reviewQuestionnaireReducer,
  actionItems: actionItemReducer,
  restrictedWords: restrictedWordsReducer,
  intents: intentsReducer,
  catalogs: catalogsReducer,
  actionItemCategories: actionItemCategoriesReducer,
  actionItemDynamicForms: actionItemDynamicFormReducer,
  variants: variantsReducer,
  upsellLeads: upsellLeadsReducer,
  reportRevenue: reportRevenueReducer,
  messageSequence: messageSequenceReducer,
  sequenceDebug: sequenceDebugReducer,
  moduleSetting: moduleSettingReducer,
  room: roomReducer,
  agentTools: agentToolsReducer,
  catalogProducts: catalogProductsReducer,
  onboardingChecklist: onboardingChecklistReducer,
   externalLeads: combineReducers({
      statusLifeCycle: externalLeadsLifeCycleReducer,
    }),
});


export const rootReducer = (state: IStoreState | undefined, action: any) => {
  if (action.type === "USER_LOGOUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
